export default "__VITE_ASSET__680208f5__"